import React, { useState, useContext } from "react";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { UserContext } from "./UserContext";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  btn: { backgroundColor: "#5865F2", color: "#fff", "&:hover": { backgroundColor: "#4752c4" } },
  error: { color: "red" },
}));

export default function LinkDiscord() {
  const classes = useStyles();
  const { setUser } = useContext(UserContext);
  const [message, setMessage] = useState("");

  const handleLink = () => {
    const popup = window.open(
      `${process.env.REACT_APP_API_URL}/api/auth/discord`,
      "discordLink",
      "width=500,height=700,left=200,top=100"
    );

    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      setMessage("Popup was blocked. Please allow popups for this site and try again.");
      return;
    }

    popup.focus();

    const timer = setInterval(() => {
      if (popup.closed) {
        clearInterval(timer);
        fetch(`${process.env.REACT_APP_API_URL}/api/auth/validate`, { credentials: "include" })
          .then((r) => r.json())
          .then((json) => {
            if (json && json.discordId) {
              localStorage.setItem("user", JSON.stringify(json));
              setUser(json);
            } else {
              setMessage("Discord linking failed or was cancelled. Please try again.");
            }
          });
      }
    }, 500);
  };

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.wrapper}>
        <img src="https://i.imgur.com/5dhiJgO.png" alt="StalkerZ" />
        <Typography variant="h6">Link Your Discord Account</Typography>
        <Typography variant="body2" align="center" color="textSecondary">
          Before you can access the whitelist portal, you must link your Discord account.
          This lets us verify your Discord ID for server management.
        </Typography>
        <Button
          fullWidth
          variant="contained"
          className={classes.btn}
          onClick={handleLink}
        >
          Link Discord
        </Button>
        {message && <Typography className={classes.error} variant="body2">{message}</Typography>}
      </div>
      <Box mt={4}>
        <Typography variant="body2" color="textSecondary" align="center">
          StalkerZ {new Date().getFullYear()}
        </Typography>
      </Box>
    </Container>
  );
}
